<script lang="ts">
import { defineComponent } from 'vue'
import ThemeStoriesBreadcrumb from './Breadcrumb.vue'
import ThemeStoriesPageHeading from './PageHeading.vue'
import ThemeStoriesMain from './Main.vue'
import ThemeStoriesAsideSecondary from './AsideSecondary.vue'
import FooterGlobal from '@/components/_core/FooterGlobal.vue'

export default defineComponent({
  name: 'ThemeStoriesApp',

  components: {
    FooterGlobal,
    ThemeStoriesBreadcrumb,
    ThemeStoriesPageHeading,
    ThemeStoriesMain,
    ThemeStoriesAsideSecondary,
  },
})
</script>

<template>
  <TemplateDefault>
    <template #breadcrumbHeader>
      <ThemeStoriesBreadcrumb />
    </template>

    <template #pageHeading>
      <ThemeStoriesPageHeading />
    </template>

    <template #main>
      <ThemeStoriesMain />
    </template>

    <template #asideSecondary>
      <ThemeStoriesAsideSecondary />
    </template>

    <template #breadcrumbFooter>
      <ThemeStoriesBreadcrumb />
    </template>

    <template #footer>
      <FooterGlobal />
    </template>
  </TemplateDefault>
</template>
